var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.1641V19.1641C22 17.3002 20.7252 15.7341 19 15.2901M15.5 3.45482C16.9659 4.04821 18 5.48537 18 7.16406C18 8.84275 16.9659 10.2799 15.5 10.8733M17 21.1641C17 19.3003 17 18.3684 16.6955 17.6333C16.2895 16.6532 15.5108 15.8745 14.5307 15.4685C13.7956 15.1641 12.8638 15.1641 11 15.1641H8C6.13623 15.1641 5.20435 15.1641 4.46927 15.4685C3.48915 15.8745 2.71046 16.6532 2.30448 17.6333C2 18.3684 2 19.3003 2 21.1641M13.5 7.16406C13.5 9.3732 11.7091 11.1641 9.5 11.1641C7.29086 11.1641 5.5 9.3732 5.5 7.16406C5.5 4.95492 7.29086 3.16406 9.5 3.16406C11.7091 3.16406 13.5 4.95492 13.5 7.16406Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/UsersIcon.e852097d20c347151c6002d33c71b4a4.svg";
export { ForwardRef as ReactComponent };